<div class="activity-booking" *ngIf="selectedIndex == 0">
    <div class="booking-group">
        <div class="row margin-neg">
            <div class="col-lg-3 col-md-4 filter-tab" *ngIf="bookingValue !== 0">
                <div class="txt-bold">
                    {{'filterBy' | translate}}
                </div>
            </div>
            <div class="col-lg-7 col-md-6">
                <div class="font-size-18px activity-title">
                    {{'ActivityDetails' | translate}}
                </div>
                <mat-radio-group aria-label="'SelectBookoingType' | translate" (change)="setBookingType($event)"
                    *ngIf="activityService.operation === Operation.create">
                    <mat-radio-button value="1" [checked]="bookingValue === ActivityBookingType.ClassBooking">
                        {{'BookaLesson' | translate}}
                    </mat-radio-button>
                    <mat-radio-button value="0" [checked]="bookingValue === ActivityBookingType.OpenBooking">
                        {{'ReserveaLocation' | translate}}
                    </mat-radio-button>
                    <mat-radio-button value="2" [checked]="bookingValue === ActivityBookingType.PrivateLesson">
                        {{'PrivateLesson' | translate}}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
    </div>
    <div class="activity-selector" *ngIf="bookingValue === ActivityBookingType.ClassBooking">
        <app-activity-class-booking></app-activity-class-booking>
    </div>
    <div class="activity-selector" *ngIf="bookingValue === ActivityBookingType.OpenBooking">
        <app-open-booking-selector></app-open-booking-selector>
    </div>
    <div class="activity-selector" *ngIf="bookingValue === ActivityBookingType.PrivateLesson">
        <app-activity-class-booking></app-activity-class-booking>
    </div>
</div>